import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as ReturnCodesConstants from '../../../../../../constants/ReturnCodesConstants'
import {mapActions, mapState} from 'vuex'
export default {
  data () {
    return {
      tagEffect: 'dark',
      auditingName: '待审批',
      formData: {},
      reasonForRejection: ''
    }
  },
  methods: {
    ...mapActions('certificationAuditModule', ['searchCustomerByCondition', 'auditingCustomerById']),
    // 审批客户
    auditingCustomer () {
      this.$confirm('是否审批通过该车主认证？', '审批', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(async () => {
        let data = {
          carIds: [this.formData.id],
          verificationStatus: DictionaryConstants.PASSED,
        }
        const result = await this.auditingCustomerById(data)
        if (result && result.code !== ReturnCodesConstants.SUCCESS_CODE) {
          this.$message.warning('审批失败')
          return
        }
        this.$message({
          type: 'success',
          message: result.data
        })
        this.$router.push({path: RoutePathConstants.WX_PERSONAL_CENTER})
      }).catch(() => {
        // this.$router.push({path: RoutePathConstants.CERTIFICATION_AUDIT_VIEW})
      })
    },
    // 取消审批
    cancelAuditingCustomer () {
      this.$prompt('请输出驳回原因？', '驳回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(async ({ value }) => {
        let data = {
          carIds: [this.formData.id],
          verificationStatus: DictionaryConstants.TURN_DOWN,
          reasonForRejection: value
        }
        const result = await this.auditingCustomerById(data)
        if (result && result.code !== ReturnCodesConstants.SUCCESS_CODE) {
          this.$message.warning('驳回失败')
          return
        }
        this.$message({
          type: 'success',
          message: result.data
        })
        this.$router.push({path: RoutePathConstants.WX_PERSONAL_CENTER})
      }).catch(() => {
      })
    }
  },
  mounted () {
    const data = this.$route.query.item
    this.formData = JSON.parse(data)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/certification-audit/views/components/certification-detail.js